module.exports = __webpack_public_path__ + "img/penalty-goal-symbol.09799634.svg";